module.exports = "/images/vendor/flag-icon-css/flags/4x3/vu.svg?859836e7f7e23c3e620dc34e4bf47c79";